import {Avatar} from 'src/design/atoms/Avatar';
import {useEffect, useState} from 'react';
import {useAppSelector} from 'src/redux/hooks';
import {getUrlWithEncodingAndAuth} from 'src/shared/utils/urlHelpers';

export interface ProfileAvatarProps {
  src?: string;
  alt: string;
}
export const ProfileAvatar = ({src, alt}: ProfileAvatarProps) => {
  const {accessToken} = useAppSelector(state => state.auth);
  const [avatarUrl, setAvatarUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    try {
      if (src) {
        const urls = src && JSON.parse(src);
        if (urls && urls[0]) {
          setAvatarUrl(getUrlWithEncodingAndAuth(urls[0].value, accessToken));
          return;
        }
      }
    } catch {
      /* empty */
    }

    setAvatarUrl(undefined);
  }, [src, accessToken]);

  return <Avatar alt={alt} src={avatarUrl} radius="xl" />;
};
